/* eslint-disable @typescript-eslint/no-explicit-any */
import { getClient } from 'azure-devops-extension-api';
import { WorkItemTrackingRestClient, FieldType } from 'azure-devops-extension-api/WorkItemTracking';
import { WorkItemTrackingProcessRestClient } from 'azure-devops-extension-api/WorkItemTrackingProcess';

export const getFieldType = (value: number) => FieldType[value];

export async function getPickListProcess(listId: string) {
	const client = getClient(WorkItemTrackingProcessRestClient);
	return client.getList(listId);
}

export async function getField(fieldNameOrRefName: string) {
	const client = getClient(WorkItemTrackingRestClient);
	return await client.getField(fieldNameOrRefName);
}